import Button from "../../components/Button";
import { View } from "react-native";
import { Feather } from "@expo/vector-icons";

export const renderAssessmentButton = (
  memberVideoStatus: string | null,
  watched: boolean,
  handleAssessmentPress: () => void
) => {
  let buttonText: string;
  let iconName: keyof typeof Feather.glyphMap | null;
  let disabled = false;

  switch (memberVideoStatus) {
    case "Completed":
      buttonText = "Assessment Completed";
      iconName = "check";
      disabled = true;
      break;
    case "Unavailable":
      buttonText = "Assessment Unavailable";
      iconName = "info";
      disabled = true;
      break;
    default:
      buttonText = "Take Assessment";
      if (watched) {
        iconName = null;
      } else {
        iconName = null;
        disabled = true;
      }
  }

  return (
    <View className="w-full px-6 sm:w-[500px] sm:px-0">
      <Button
        mode="contained"
        onPress={handleAssessmentPress}
        icon={iconName ? iconName : undefined}
        iconPosition="right"
        isValid={!disabled}
      >
        {buttonText}
      </Button>
    </View>
  );
};
